import React from 'react';

const ErrorContainer = ({
    children,
    className = '',
    style = {},
    ...otherProps
}) => (
    <div
        className={`w-100 h-100 d-flex justify-content-center align-items-center ${className}`}
        style={{ minHeight: '50vh', ...style }}
        {...otherProps}>
        <div className="text-center">{children}</div>
    </div>
);

export default ErrorContainer;
